export const DELETE_PHONE_URL = 'v1/account/objects/:id/phones/:phoneId/'